import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { copiarTextoAlPortapapeles } from "../../helper/funciones";

const BotonCopiar = ({
  texto,
  className = "mensaje-copy-button",
  ariaLabel = "Copiar",
}) => {
  const [copiado, setCopiado] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const copiarAlPortapapeles = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const ok = await copiarTextoAlPortapapeles(texto);

    if (!ok) {
      return;
    }

    setCopiado(true);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setCopiado(false);
    }, 1500);
  };

  if (!texto) {
    return null;
  }

  return (
    <Tooltip title={copiado ? "Copiado" : "Copiar"}>
      <IconButton
        aria-label={ariaLabel}
        className={className}
        onClick={copiarAlPortapapeles}
        size="small"
      >
        {copiado ? (
          <CheckIcon fontSize="small" />
        ) : (
          <ContentCopyIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default BotonCopiar;